import { Button } from "../ui/button"
import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { useEffect, useState } from "react";

import styles from "../../styles/base/Login.module.scss";
import { getContent } from "../../functions/general/translations";
import { useAppSelector } from "../../hooks/redux";
import { Loader2, MoveRight } from "lucide-react";
import axios from "src/axios/axios";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { encryptObject } from "src/lib/crypt";
import { addHours, addWeeks } from "date-fns";
import useAuth from "src/hooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";
import { CONFIG } from "src/config";
import { setCookie } from "src/functions/general/cookies";

export default function LoginForm({...props}){
    const {setAuth} = useAuth()
    const navigate = useNavigate()
    const location = useLocation();
    const {t} = useTranslation()
    const from = location.state?.from?.pathname || "/"

    const [persist, setpersist] = useState(true);
    const [email, setemail] = useState('');
    const [clientcode, setclientcode] = useState(CONFIG.defaultClientcode ? CONFIG.defaultClientcode : (window.localStorage.getItem("clientcode") ?? ""));
    const [password, setpassword] = useState('');

    const onEnter = (e:any) => {
        if(e.key === "Enter"){
            handleLogin()
        }
        document.removeEventListener("keypress", e);
    }

    useEffect(()=>{
        document.addEventListener("keypress", onEnter)

        return () => {
            document.removeEventListener("keypress", onEnter)
        }
    }, [])

    const { mutate:handleLogin, isLoading:isLoadingLogin, reset, isError } = useMutation({
        mutationFn: async () => {
            const {data} = await axios.post(`authenticate`, {
                clientcode: clientcode,
                username: email,
                password: password, 
            })
            if(data.errorcode!==0){throw new Error(data.message)}
            let expiry = addHours(new Date(), 1)
            if(persist){
                expiry = addWeeks(new Date(), 1)
            }
            setCookie('fit-token', data?.object?.token)
            
            const jwt = encryptObject({ username:email, password, clientcode, expiry:expiry }, process.env.REACT_APP_SECRET!)
            setCookie("jwt", jwt);
            
            window.localStorage.setItem("clientcode", clientcode);

            setAuth({status:'authenticated', data: data.object})
            navigate(from, { replace:true });
        },
        onError: () => { setTimeout(()=>{ reset() }, 2000) }
    })

    return (
        <div className={styles.loginform}>
            <div className={styles.loginform_wrapper}>
                <div className={styles.content}>
                    <h1 className='text-2xl font-bold'>{t("Login.title")}</h1>
                    <p className={styles.description}>{t("Login.description")}</p>
                </div>
                
                {!CONFIG.hideClientcode &&
                <div className={styles.input}>
                    <p className={styles.label}>{t("Login.clientcode_label")}</p>
                    <Input value={clientcode} onChange={(e)=>{setclientcode(e.currentTarget.value)}} type="text" placeholder="1234"/>
                </div>
                }
                
                <div className={styles.input}>
                    <p className={styles.label}>{t("Login.email_label")}</p>
                    <Input value={email} onChange={(e)=>{setemail(e.currentTarget.value)}} type="text" placeholder="patrick@voorbeeld.be"/>
                </div>
                
                <div className={styles.input}>
                    <div className={styles.label_wrapper}>
                        <p className={styles.label}>{t("Login.password_label")}</p>
                        {/* <p onClick={()=>{onForgotPassword()}} className={`${styles.label} ${styles.label_password}`}>{t("Login.forgotpassword_label")}</p> */}
                    </div>
                    <Input value={password} onChange={(e)=>{setpassword(e.currentTarget.value)}} type="password" placeholder="**********"/>
                </div>

                <div className="flex items-center gap-1">
                <Checkbox checked={persist} onCheckedChange={(v)=>{setpersist(v as boolean)}} id="remember"/>
                <Label htmlFor="remember">{t("Login.rememberme_label")}</Label>
                </div>
                
                <Button onClick={()=>{handleLogin()}} className={`${isError && 'bg-red-700'}`} disabled={isLoadingLogin}>
                    <div className="flex items-center gap-1">
                        {isError ? 'Er liep iets mis' :<>
                        {t("Login.login_button")}
                        {isLoadingLogin ? <Loader2 className="w-5 animate-spin"/> : <MoveRight className="w-5"/>}
                        </>}
                    </div>
                </Button>
            </div>
        </div>
    )
}